import React from 'react';
import { Box, useTheme } from "@mui/material";
import { Line } from "react-chartjs-2";
import ChartDataLabels from 'chartjs-plugin-datalabels';
import {Chart, PointElement, LineElement} from 'chart.js';
import { useTranslation } from "react-i18next";

Chart.register(PointElement);
Chart.register(LineElement)

export default function HistoryPlayerStrengthChart({history}) {
    const theme = useTheme()
    const { t } = useTranslation()

    const historyFiltered = React.useMemo(() => history.filter(el => !el["p"]), [history]);

    const ranks = historyFiltered.map(el => el["rs"] ? Math.round(el["rs"] / 10) * 10 : null);

    const options = {
        layout: {
            padding: {
                top: 0, // Adjust this value to add more or less padding to the top
                right: 10,
                bottom: 0,
                left: 10
            }
        },
        responsive: true,
        aspectRatio: 2,
        plugins: {
            legend: {
            display: false,
            position: "bottom"
            },
            tooltip: {
                enabled: false,
            },
            datalabels: {
                backgroundColor: function(context) {
                    return context.dataset.backgroundColor;
                },
                borderRadius: 4,
                color: 'white',
                font: {
                    weight: 'bold',
                    size: 10,
                },
                formatter: (value, context) => "P" + value,
                padding: 4,
            }
        },
        interaction: {
            intersect: false,
            mode: 'index',
        },
        elements: {
          line: {
            fill: false,
            tension: 0.9
          }
        },
        scales: {
            y: {
                maxRotation: 0,
                display: true,
                ticks: {
                    display: false,
                    //stepSize: 100,
                },
                border: {
                    display: false,
                },
                grid: {
                    display: true,
                },
                min: 0,
                max: Math.max(...ranks.filter(el => el !== null)) + 200,
            },
            x: {
                offset: true,
            grid: {
                display: true,
            },
            //ticks: {
            //  maxRotation: 0
            //}
            }
        },
        };
        
    const chartData = {
        labels: historyFiltered.map(el => el["l"]),
        datasets: [
        {
            label: t("userCard.chartLabel"),
            data: ranks,
            backgroundColor: historyFiltered.map(el => el["p"] ? "#ddb0ff" : theme.palette.primary.main),
            borderColor: theme.palette.primary.main,
            borderRadius: 5,
            cubicInterpolationMode: 'monotone',
        },
        ],
    
    };
            
    return <Box sx={{display: "flex", flexDirection: "column", alignItems: "center", pt: 2, pb: 1, width: "100%"}}>
        <Line options={options} data={chartData} plugins={[ChartDataLabels]} />
    </Box>;
}